import React from 'react';
import { Icon, Space, Title } from '@bb/elements-web';
import styled from 'styled-components';
import {
  MarketingBadgeApple,
  MarketingBadgeGoogle,
} from 'components/MarketingBadges';
import { StyledCard, StyledText } from './styledComponents';

export default function SingleAccessSuccessCard() {
  return (
    <StyledCard $bordered={false} $noPadding>
      <Space size={24} direction="vertical">
        <IconWrapper>
          <Icon icon="checkOutlined" color="primary" size={24} />
        </IconWrapper>
        <Space size={8} direction="vertical" align="center">
          <Title
            dataCy="single-access-success-title"
            level={4}
            textAlign="center"
            margin={0}
          >
            Success! Your account has been created.
          </Title>
          <StyledText
            size="large"
            $secondary
            $alignCenter
            style={{ marginBottom: '8px' }}
          >
            Download the app and log in with your email to get started.
          </StyledText>
          <Space direction="horizontal" size={16} align="center">
            <MarketingBadgeApple />
            <MarketingBadgeGoogle />
          </Space>
        </Space>
      </Space>
    </StyledCard>
  );
}

const IconWrapper = styled.div`
  background-color: #f0f7ff;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
`;
